import { render, staticRenderFns } from "./BatchIpt2Sale.vue?vue&type=template&id=02bbafcc&scoped=true&"
import script from "./BatchIpt2Sale.vue?vue&type=script&lang=js&"
export * from "./BatchIpt2Sale.vue?vue&type=script&lang=js&"
import style0 from "./BatchIpt2Sale.vue?vue&type=style&index=0&id=02bbafcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bbafcc",
  null
  
)

export default component.exports